var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBtnDownSelect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 8,
    viewBox: "0 0 12 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M5.14729 7.15095C5.08659 7.09201 5.03536 7.02808 4.99081 6.96081L0.340182 2.46084C-0.113323 2.02184 -0.113538 1.30961 0.340397 0.870397C0.794117 0.431187 1.53001 0.431187 1.98416 0.870397L5.98951 4.74581L10.0157 0.850404C10.4694 0.411194 11.2051 0.411194 11.6595 0.850404C11.8868 1.07011 12 1.35813 12 1.64552C12 1.93291 11.8868 2.22114 11.6595 2.44064L6.98735 6.96081C6.94279 7.02808 6.89157 7.09243 6.83087 7.15095C6.59884 7.37544 6.29321 7.48374 5.98908 7.47832C5.68495 7.48374 5.37953 7.37544 5.14729 7.15095Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBtnDownSelect);
export default __webpack_public_path__ + "static/media/btnDownSelect.8258d0899c78acbbbb982a5c556cfbfb.svg";
export { ForwardRef as ReactComponent };